import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { AuthService } from 'src/app/services/auth.service';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.css']
})
export class AdminHomeComponent implements OnInit {

    // Password object
    update = {
      password: '',
      confirmPassword: ''
    }

    // Template variables
    resetMode = false;

    challengesCount?: number;

    constructor(public auth: AuthService, private router: Router, private flashMessage: FlashMessagesService, private admin: AdminService) { }

    ngOnInit(): void {
      console.log('admin-home init');

      this.loadChallenges();
    }

  private async loadChallenges() {
    if (this.auth.isSuperAdmin) {
      this.challengesCount = await this.admin.getChallengesCount().toPromise();
    }
  }

  // Submit reset password
  onSubmit() {
    this.resetMode = false;

    // Send request
    this.auth.resetAdminpasswordloggedin({ password: this.update.password, user: this.auth.user }).toPromise().then((data: any) => {

      // Successful reset
      if (data.success) {

        // Show success
        this.flashMessage.show("Password successfully reset.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }

      // Password reset failed
      else {
        this.flashMessage.show("Password reset failed.", {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }

      // Reset
      this.update.password = '';
      this.update.confirmPassword = '';
    });
  }
}
